import { ApplicationConfig, importProvidersFrom, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { provideZoneChangeDetection } from '@angular/core';
import { routes } from './app.routes';
import { registerAppLocales } from './core/i18n/app-locale';
import { LocalizationModule } from './core/i18n/localization.module';
import { candidateAuthRefreshInterceptor } from './core/interceptors/candidate-auth-refresh.interceptor';
import { handleCommonResponseInterceptor } from './core/interceptors/handle-common-response.interceptor';
import { handleRequestHeaderInterceptor } from './core/interceptors/handle-request-header.interceptor';

registerAppLocales();

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection(),
    provideAnimations(),
    provideRouter(routes),
    importProvidersFrom(LocalizationModule.forRoot()),
    provideHttpClient(
      withInterceptors([handleRequestHeaderInterceptor, candidateAuthRefreshInterceptor, handleCommonResponseInterceptor]),
    ),
  ],
};
